<script lang="ts">
  import { onMount } from 'svelte';
  interface DropdownOption {
    label: string;
    value: string;
    icon?: string;
  }

  let isOpen = false;
  let dropdownContainer: HTMLDivElement;
  export let options: DropdownOption[] = [];
  export let onSelectedOption = (option: DropdownOption) => {};

  const toggleMenu = (event: MouseEvent) => {
    event.stopPropagation();
    isOpen = !isOpen;
  };

  function handleOptionClick(option: DropdownOption) {
    onSelectedOption(option);
    isOpen = false;
  }

  function handleClickOutside(event: MouseEvent) {
    if (!isOpen) return;
    if (dropdownContainer && !dropdownContainer.contains(event.target as Node)) {
      isOpen = false;
    }
  }

  onMount(() => {
    setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });
</script>

<div class="relative" bind:this={dropdownContainer}>
  <button on:click={toggleMenu} type="button" class="relative inline-flex items-center">
    <slot name="button" />
  </button>
  {#if isOpen}
    <div
      class="absolute right-0 z-50 mt-2 w-[calc(100vw-2rem)] sm:w-[420px] origin-top-right rounded-2xl bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabindex="-1"
    >
      <div class="bg-white rounded-t-2xl px-3 sm:px-5 py-4">
        <slot name="customComponent" />
      </div>
      <div class="border-t border-gray-100 bg-gray-50/50 px-2 py-2 rounded-b-2xl">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
          {#each options as option (option.label)}
            <button
              class="group flex w-full items-center gap-2.5 rounded-xl px-3 py-2 text-sm text-gray-700 hover:bg-white hover:shadow-sm focus:bg-white focus:outline-none transition-all duration-200"
              role="menuitem"
              type="button"
              tabindex="-1"
              on:click={() => handleOptionClick(option)}
            >
              {#if option.icon}
                <span
                  class="text-gray-400 group-hover:text-indigo-600 transition-colors duration-200"
                >
                  {@html option.icon}
                </span>
              {/if}
              <span class="font-medium">{option.label}</span>
            </button>
          {/each}
        </div>
      </div>
    </div>
  {/if}
</div>

<style>
  button {
    -webkit-tap-highlight-color: transparent;
  }

  :global(.group:hover svg) {
    color: rgb(79 70 229 / 1);
  }
</style>
